import { Link } from 'react-router-dom'
import { Monitor, HardDrive, Server } from 'lucide-react'

export default function SoftwareIndex() {
  return (
    <div className="docs-index">
      <section className="section docs-index-hero">
        <p className="docs-index-eyebrow">Software</p>
        <h1 className="docs-index-title">Q-Play software</h1>
        <p className="docs-index-sub">
          Players, the content cache proxy, and the integration server - install, configure, and
          operate the software that runs Q-Play.
        </p>
      </section>

      <section className="section lp-section">
        <div className="lp-section-head"><h2 className="lp-section-title">Components</h2></div>
        <div className="lp-cards lp-cards-3">
          <Link to="/software/player-software" className="lp-tile">
            <span className="lp-icon lp-icon-chip"><Monitor size={20} /></span>
            <h3>Player software</h3>
            <p>Install, configure, and manage player software across devices and environments.</p>
          </Link>
          <Link to="/software/content-cache-proxy" className="lp-tile">
            <span className="lp-icon lp-icon-chip"><HardDrive size={20} /></span>
            <h3>Content Cache Proxy</h3>
            <p>Optimize content delivery by caching media close to your Q-Play players.</p>
          </Link>
          <Link to="/software/integration-server" className="lp-tile">
            <span className="lp-icon lp-icon-chip"><Server size={20} /></span>
            <h3>Integration Server</h3>
            <p>Connect external systems to Q-Play using our Integration Server.</p>
          </Link>
        </div>
      </section>
    </div>
  )
}
